define('plugin/product/view/ProductItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Product item view
     *
     * @class ProductItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#product_item_view_list';
            }
            return '#product_item_view';
        },
        ui: {
            'qty': '.sb-qty',
            'add': '.sb-add'
        },
        events: {
            'change @ui.qty': 'onQtyChanged',
            'change @ui.add': 'onAddChanged'
        },

        onQtyChanged: function () {
            this.model.set('qty', this.ui.qty.val());
        },

        onAddChanged: function () {
            if (this.ui.add.is(':checked')) {
                this.model.set('qty', 1);
            } else {
                this.model.set('qty', 0);
            }
            this.ui.qty.val(this.model.get('qty'));
        }

    });

});
